import { getUiPictureData } from '@academica-box/helpers/getUiPictureData'
import { Config, Connect } from '@vkontakte/superappkit'
import type {
  IVKConnect,
  VKConnectAuthData,
  VKConnectFullUserData,
  VKConnectOptions,
  VKConnectUserData
} from '@/plugins/VKConnect/types'

export class VKConnect implements IVKConnect {
  appId: number
  appSettings?: object
  superAppToken: string
  isLogEnable?: boolean
  floatingOneTapAuth?: object | null
  isSilentAuthSuccess: boolean
  tokenChangeFunction: Function
  onUseDataChange: Function
  logger: Function
  _userData: VKConnectUserData | null
  authData: VKConnectAuthData | null
  constructor(options: VKConnectOptions) {
    this.appId = options.appId
    this.appSettings = options.appSettings
    this.tokenChangeFunction = options.tokenChangeFunction
    this.onUseDataChange = options.onUseDataChange
    this.logger = options.logger
    this.superAppToken = options.superAppToken || ''
    this.isLogEnable = options.isLogEnable || false
    this._userData = null
    this.authData = null
    this.isSilentAuthSuccess = false

    this.floatingOneTapAuth = null
  }

  init() {
    this.initApp()
  }

  get userData() {
    return this._userData
  }

  set userData(data: VKConnectUserData | null) {
    this._userData = data
    this.onUseDataChange(this._userData)
  }

  initApp() {
    Config.init({
      appId: this.appId,
      appSettings: this.appSettings,
      superAppToken: this.superAppToken,
      _debug: this.isLogEnable,
      _localhost: false
    })

    Config.onRequestSuperAppToken(() => {
      Config.setSuperAppToken(this.superAppToken)
    })

    Config.onAuth(() => {
      this.userVisibleAuth()
    })

    Connect.silentAuth().then((data) => {
      this.log('SilentAuth success: ', data)
      this.isSilentAuthSuccess = !!data?.payload?.auth

      if (this.isSilentAuthSuccess) {
        this.authData = {
          uuid: data?.payload?.uuid,
          token: data?.payload?.token,
          type: data?.payload?.type,
        }

        this.userData = {
          authType: 'silent',
          firstName: data?.payload?.user?.first_name,
          lastName: data?.payload?.user?.last_name,
          email: data?.payload?.user?.email,
          phone: data?.payload?.user?.phone,
          avatar: getUiPictureData({ sm: [data?.payload?.user?.avatar] }),
        }
      }
    }).catch((err) => {
      // TODO непонятно надо ли логать т.к. при cors постоянно валится, но err отсутствует, других причин не увидел
      if (err) {
        this.sendErrorMessage('Не удалось выполнить Silent Auth', err)
      }
    })
  }

  async userVisibleAuth() {
    await Connect.userVisibleAuth().then(async (data) => {
      this.log('VisibleAuth success: ', data)

      if ('payload' in data) {
        this.authData = {
          uuid: data.payload.uuid,
          token: data.payload.token,
          type: data.payload.type,
        }

        this.userData = this.userData = {
          authType: 'silent',
          firstName: data.payload.user?.first_name,
          lastName: data.payload.user?.last_name,
          email: data.payload.user?.email,
          phone: data.payload.user?.phone,
          vkID: data.payload.user?.id,
          avatar: getUiPictureData({ sm: [data.payload.user?.avatar] }),
        }

        await this.changeToken()
      }
    }).catch((err) => {
      const isCloseWindow = err && err.code === 7

      if (!isCloseWindow) {
        this.sendErrorMessage('Не удалось авторизоваться через попап', err)
      }
    })
  }

  async login() {
    if (this.isSilentAuthSuccess) {
      await this.changeToken()
    } else {
      await this.userVisibleAuth()
    }
  }

  async changeToken() {
    await this.tokenChangeFunction(this.authData)
      .then((user: VKConnectFullUserData) => {
        if (this.userData) {
          this.userData = {
            ...this.userData,
            authType: 'full',
            firstName: user.first_name,
            lastName: user.last_name,
            email: user.email,
            phone: user.phone,
          }
        }
      }).catch((err: any) => {
        this.sendErrorMessage('Ошибка авторизации на сервере', err)
      })
  }

  sendErrorMessage(event: string, data: any) {
    event = `[Vk-Connect]: ${event}`

    this.log(event, data)
    this.logger(new Error(event))
  }

  log(event: string, data: any) {
    if (this.isLogEnable) {
      console.log(event, data)
    }
  }
}
